import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { CompanyMspInProductTrialsTabController } from '../controller/CompanyMspInProductTrialsTabController';
import { CompanyFeatures, MspInProductTrials } from '../../../types/company-data';

export class CompanyMspInProductTrialsTabWebComponent extends BaseWebComponentElement {
  public controller!: CompanyMspInProductTrialsTabController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CompanyMspInProductTrialsTabController,
    });
  }

  public get hasUnsavedChanges(): boolean {
    // there are no forms in "Msp in product trials" tab which can have unsaved changes
    return false;
  }

  public get isVideoPlaying(): boolean {
    return this.controller.isVideoPlaying();
  }

  public discardFormChanges(): void {
    return this.controller.view.discardFormChanges();
  }

  public setTrialFeatures(companyFeatures: CompanyFeatures, mspInProductTrials: MspInProductTrials | undefined) {
    this.controller.setTrialFeatures(companyFeatures, mspInProductTrials);
  }

  public setCompanySelectedCountry(companySelectedCountry: string): void {
    this.controller.setCompanySelectedCountry(companySelectedCountry);
  }

  public setCompanySelectedIndustry(setCompanySelectedIndustry: number): void {
    this.controller.setIndustrySelectedIndustry(setCompanySelectedIndustry);
  }

  public setCompanySelectedState(companySelectedState: string): void {
    this.controller.setCompanySelectedState(companySelectedState);
  }

  get companyId(): string {
    const data = this.getAttribute('data-company-id');
    return data ?? '';
  }

  set companyId(companyId: string) {
    this.setAttribute('data-company-id', companyId);
  }

  public refreshLandingPage(): void {
    this.controller.view.updateLandingPage();
  }

  public refreshTab(): void {
    this.controller.view.buildTab();
  }
}
